import { useCallback, useState } from 'react';

export default function useRerender(): () => void {
  const [, setRunningIndex] = useState<number>(0);

  return useCallback(function (): void {
    setRunningIndex((runningIndex) => runningIndex + 1);
  }, []);
}
